export const getters = {
  IS_AUTH: (state) => state.is_auth,
  USER: state => state.user,
  ROLE_NAME: state => state.role_name,
}
